(function () {
	var CURRENT_PARTNER_STATE_VERSION = "2026-04-20";
	function getRoutesRoot() {
		var root =
			(window.Shopify &&
				window.Shopify.routes &&
				window.Shopify.routes.root) ||
			(window.theme && window.theme.routes && window.theme.routes.root) ||
			"/";

		return /\/$/.test(root) ? root : root + "/";
	}

	function buildShopifyUrl(path) {
		return getRoutesRoot() + String(path || "").replace(/^\/+/, "");
	}

	function normalizeTarget(rawTarget) {
		if (!rawTarget) {
			return buildShopifyUrl("");
		}

		var decodedTarget = rawTarget.trim();

		if (!decodedTarget) {
			return buildShopifyUrl("");
		}

		if (/^https?:\/\//i.test(decodedTarget) || decodedTarget.indexOf("//") === 0) {
			return buildShopifyUrl("");
		}

		if (decodedTarget.charAt(0) !== "/") {
			decodedTarget = "/" + decodedTarget;
		}

		if (!/^\/(?:$|pages\/|products\/|collections\/)/.test(decodedTarget)) {
			return buildShopifyUrl("");
		}

		return decodedTarget;
	}

	function normalizePartner(rawPartner, hasPartnerParam) {
		if (!hasPartnerParam) {
			return null;
		}

		var partner = String(rawPartner || "").trim();

		if (!partner) {
			return "";
		}

		if (!/^[a-z0-9_-]{1,64}$/i.test(partner)) {
			return null;
		}

		return partner;
	}

	function updateStatus(message) {
		document.querySelectorAll(
			"[data-partner-status], [data-partner-loading-status]"
		).forEach(function (status) {
			status.textContent = message;
		});
	}

	function updateFallback(target) {
		var link = document.querySelector("[data-partner-fallback]");
		if (link) {
			link.href = target;
		}
	}

	function buildCurrentPageTarget(currentUrl) {
		var nextUrl = new URL(currentUrl.toString());

		nextUrl.searchParams.delete("partner");
		nextUrl.searchParams.delete("target");
		nextUrl.searchParams.delete("page");

		return nextUrl.pathname + (nextUrl.search || "") + (nextUrl.hash || "");
	}

	async function persistPartner(partner) {
		var payload = new URLSearchParams();
		payload.set("attributes[Partner]", partner);
		payload.set(
			"attributes[PartnerVersion]",
			partner ? CURRENT_PARTNER_STATE_VERSION : ""
		);

		var controller = new AbortController();
		var timeout = setTimeout(function () {
			controller.abort();
		}, 10000);
		try {
			var response = await fetch(buildShopifyUrl("cart/update.js"), {
				method: "POST",
				headers: {
					"Content-Type":
						"application/x-www-form-urlencoded; charset=UTF-8",
					Accept: "application/json"
				},
				body: payload.toString(),
				credentials: "same-origin",
				signal: controller.signal
			});

			if (!response.ok) {
				throw new Error("cart update failed");
			}
			var cart = await response.json();
			var attributes = cart.attributes || {};
			if (
				(attributes.Partner || "") !== partner ||
				(attributes.PartnerVersion || "") !==
					(partner ? CURRENT_PARTNER_STATE_VERSION : "")
			) {
				throw new Error("partner state was not saved");
			}
		} finally {
			clearTimeout(timeout);
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		var currentUrl = new URL(window.location.href);
		var isPartnerLanding = !!document.querySelector("[data-partner-status]");
		var hasPartnerParam = currentUrl.searchParams.has("partner");
		var target = isPartnerLanding
			? normalizeTarget(
					currentUrl.searchParams.get("target") ||
						currentUrl.searchParams.get("page")
				)
			: buildCurrentPageTarget(currentUrl);
		var partner = normalizePartner(
			currentUrl.searchParams.get("partner"),
			hasPartnerParam
		);
		var currentPartnerCode =
			(window.theme && window.theme.partner && window.theme.partner.code) ||
			"";
		var currentPartnerVersion =
			(window.theme &&
				window.theme.partner &&
				window.theme.partner.version) ||
			"";

		updateFallback(target);

		if (
			!hasPartnerParam &&
			currentPartnerCode &&
			currentPartnerVersion !== CURRENT_PARTNER_STATE_VERSION
		) {
			persistPartner("")
				.then(function () {
					window.location.replace(target);
				})
				.catch(function () {
					updateStatus("Partner setup failed. Please try again.");
				});
			return;
		}

		if (partner === null) {
			document.documentElement.classList.remove("partner-pending");
			if (isPartnerLanding) {
				updateStatus("Missing or invalid partner code. Redirecting.");
				window.location.replace(target);
			}
			return;
		}

		if (
			!isPartnerLanding &&
			partner === currentPartnerCode &&
			currentPartnerVersion === (partner ? CURRENT_PARTNER_STATE_VERSION : "")
		) {
			document.documentElement.classList.remove("partner-pending");
			window.history.replaceState(window.history.state, "", target);
			return;
		}

		if (isPartnerLanding) {
			updateStatus(
				partner
					? "Preparing your partner experience."
					: "Clearing partner experience."
			);
		}

		persistPartner(partner)
			.then(function () {
				window.location.replace(target);
			})
			.catch(function () {
				updateStatus("Partner setup failed. Please try again.");
			});
	});
})();
